import "./App.css";
import { SiApacheairflow, SiApachespark, SiClaudecode, SiClaude, SiCloudflare, SiCursor, SiImmich, SiKubernetes, SiPython, SiReact, SiTailscale } from "react-icons/si";
import { AiFillOpenAI } from "react-icons/ai";
import { FiActivity, FiMap } from "react-icons/fi";
import { TbBrandMinecraft } from "react-icons/tb";

const stack = [
  ["Python", SiPython, "#3776ab"], ["React", SiReact, "#149eca"], ["Spark", SiApachespark, "#e25a1c"],
  ["Kubernetes", SiKubernetes, "#326ce5"], ["Airflow", SiApacheairflow, "#017cee"], ["Langfuse", FiActivity, "#7659d9"],
];
const dailyDrivers = [
  ["Claude Code", SiClaudecode, "#d97757"], ["Cursor", SiCursor, "#111111"], ["Codex", AiFillOpenAI, "#10a37f"], ["Hermes", null, "#dca846"],
  ["Cloudflare", SiCloudflare, "#f38020"], ["Tailscale", SiTailscale, "#3b82f6"],
];
const homelabServices = [
  ["Minecraft", TbBrandMinecraft, "#62b47a"], ["Immich", SiImmich, "#ff6f61"],
  ["Hermes Agent", null, "#dca846"], ["Tripmate", FiMap, "#3b82b8"],
];

function Arrow() { return <span aria-hidden="true">↗</span>; }

export default function App() {
  return (
    <div className="page">
      <header className="nav" aria-label="Main navigation">
        <a className="wordmark" href="#top">TW<span>.</span></a>
        <nav>
          <a href="#about">About</a>
          <a href="#work">Work</a>
          <a href="#notes">Notes</a>
          <a href="https://github.com/Tingweiftw" target="_blank" rel="noreferrer">GitHub <Arrow /></a>
        </nav>
      </header>

      <main id="top">
        <section className="hero" aria-labelledby="intro-title">
          <p className="eyebrow">AI &amp; platform engineer · Singapore</p>
          <h1 id="intro-title">Quiet data plumber for the government.</h1>
          <p className="intro">I build central, specialised data-platform products used across the Singapore government.</p>
          <div className="actions">
            <a className="button" href="/Fan%20Ting%20Wei.pdf" target="_blank" rel="noreferrer">View résumé <Arrow /></a>
            <a className="text-link" href="#work">See selected work <span>↓</span></a>
          </div>
        </section>

        <section id="about" className="section split">
          <p className="eyebrow">01 / About</p>
          <div>
            <h2>Useful systems, from data to deployment.</h2>
            <p>I work across the stack: frontend, backend, data engineering, and DevOps - lately with a focus on LLM-powered product features.</p>
            <p>Recent work includes shipping a self-service LLM query assistant, cutting cloud spend by more than half, and keeping systems patched and secure.</p>
          </div>
        </section>

        <section id="work" className="section split work-section">
          <p className="eyebrow">02 / Selected work</p>
          <div className="projects">
            <article className="project project-visual">
              <div className="project-heading"><p className="project-index">01 / 2026</p><h3>Tripmate</h3></div>
              <div className="project-details"><img className="project-preview" src="/tripmate-preview.png" alt="Tripmate itinerary and expense-tracking interface" /><div><p>A self-hosted, multi-user travel itinerary and expense tracker with roles, permissions, and expense splitting. Built with TypeScript, Express, and SQLite; deployed on a homelab NUC through Cloudflare Tunnel.</p><a href="https://trips.tingwei.fans/" target="_blank" rel="noreferrer">Visit Tripmate <Arrow /></a></div></div>
            </article>
            <article className="project project-visual">
              <div className="project-heading"><p className="project-index">02 / 2026</p><h3>Hermes artifacts</h3></div>
              <div className="project-details"><video className="project-preview project-demo" autoPlay muted loop playsInline><source src="/hermes-demo.mp4" type="video/mp4" />Your browser does not support embedded video.</video><div><p>An open-source artifact server for Hermes Agent. It serves shareable HTML widgets through Telegram Mini Apps, with public URLs and private HMAC-authenticated access.</p><a href="https://github.com/Tingweiftw/hermes-artifacts" target="_blank" rel="noreferrer">View on GitHub <Arrow /></a></div></div>
            </article>
            <article className="project project-visual quiet-project">
              <div className="project-heading"><p className="project-index">03 / Ongoing</p><h3>Homelab</h3></div>
              <div className="project-details"><div className="homelab-services">{homelabServices.map(([name, Icon, color]) => <div className="service-tile" style={{ "--brand": color }} key={name}>{name === "Hermes Agent" ? <img className="hermes-logo" src="/hermes-agent-logo.png" alt="" /> : <Icon aria-hidden="true" />}<span>{name}</span></div>)}</div><div><p>A small self-hosted playground for services, experiments, and the systems behind them. Right now it runs Minecraft, Immich, Hermes Agent, and more.</p></div></div>
            </article>
          </div>
        </section>

        <section className="section split stack-section">
          <p className="eyebrow">03 / What I work with</p>
          <div>
            <h2>My daily drivers.</h2>
            <div className="tool-groups">
              <div><p className="tool-label">Tech stack</p><div className="icon-grid">{stack.map(([name, Icon, color]) => <div className="icon-tile" style={{ "--brand": color }} key={name}>{name === "Airflow" ? <img className="airflow-logo" src="https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/svg/apache-airflow.svg" alt="" /> : <Icon aria-hidden="true" />}<span>{name}</span></div>)}</div></div>
              <div><p className="tool-label">Tools</p><div className="icon-grid">{dailyDrivers.map(([name, Icon, color]) => <div className="icon-tile" style={{ "--brand": color }} key={name}>{name === "Hermes" ? <img className="hermes-logo" src="/hermes-agent-logo.png" alt="" /> : <Icon aria-hidden="true" />}<span>{name}</span></div>)}</div></div>
            </div>
          </div>
        </section>

        <section id="notes" className="section split">
          <p className="eyebrow">04 / Notes</p>
          <div><h2>Things I’m thinking through.</h2><p>I write occasional notes about building, learning, and the messy bits in between.</p><a className="notes-link" href="https://blog.tingwei.fans/" target="_blank" rel="noreferrer">Read the blog <Arrow /></a></div>
        </section>

        <section className="contact" aria-labelledby="contact-title">
          <p className="eyebrow">05 / Contact</p>
          <h2 id="contact-title">Have a useful problem to solve?</h2>
          <a href="mailto:tingwei.f@gmail.com">Say hello <Arrow /></a>
        </section>
      </main>

      <footer><span>© {new Date().getFullYear()} Ting Wei</span><a href="https://github.com/Tingweiftw" target="_blank" rel="noreferrer">GitHub <Arrow /></a></footer>
    </div>
  );
}
